
import React, { Component } from 'react';
import createHistory from 'history/createHashHistory';//路由切换地址
import { Button } from 'antd';//引入antd组件
import "./style.css"
import errImg from "./../../assets/images/KpnpchXsobRgLElEozzI.svg"
const history = createHistory();//定义history路由


class App extends React.Component {
    backLogin() {
        history.push({ "pathname":"/Login/LoginMain/LoginEntry"})
    }
    componentWillMount() {
        history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
    }
    render() {
        return (
            <div className="App" style={{ height: "80%", minHeight: "500px", textAlign: "center", position: "relative" }}>
                <div className="Err_wrap">
                    <img style={{ marginRight: "20px" }} src={errImg} alt="" />
                </div>
                <div className="Err_con Err_wrap" style={{ display: "inline-block" }}>
                    <h1>404</h1>
                    <p>你的页面出错啦~~</p>
                    <Button onClick={this.backLogin} type="primary">返回登录页</Button>
                </div>
               
            </div>
        );
    }
}

export default App


// WEBPACK FOOTER //
// ./src/components/Err/Err.js